export const routes = (parentName) => {
  return [
    {
      path: "story",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Story`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Story-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Story-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Story-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
